import {PaymentStatusEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function settlementPaymentStatusNameFilter(status: PaymentStatusEnum) {
  switch(status) {
    case PaymentStatusEnum.Waiting: return i18n.t(LF.Waiting) as string;
    case PaymentStatusEnum.Approved: return i18n.t(LF.Approved) as string;
    case PaymentStatusEnum.Executed: return i18n.t(LF.Finished) as string;
  }
}
